exports = module.exports = require("../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kayenta-list a.clickable {\n  margin: 5px 0 0 10px;\n}\n.kayenta-list input.input-sm {\n  width: 93%;\n}\n", ""]);

